import React, {Component} from 'react';
import Header from './Layout/Header';
import {Content} from './Layout/Content';
import Footer from './Layout/Footer';

class App extends Component {
  render() {
    return (
      <div>
        <Header/>
        <Content/>
        <Footer id="contactUs"/>
      </div>
    );
  }
}

export default App;
